<template>
  <div>
    <div class="top_link" v-if="windowWidth > 769">
      <div class="page_width">
        <template>
          <!-- UserMessage.UserName == '' ||  -->
          <div v-if="UserMessage.UserName == undefined " class="logout">
            <ul class="clearfix">
              <li class="register">
                <span id="more"
                  >更多内容，请进入
                  <a
                    href="https://www.drcnet.com.cn/?g=1"
                    target="_blank"
                    class="yellow"
                    >国研网</a
                  >
                  |</span
                >
                <span style="cursor: pointer" @click="loginDrc"> 登录 </span>
                <!-- <a
                :href="`http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx?gourl=${url}`"
              >
                登录
              </a> -->
              </li>

              <!-- <a
              :href="`http://d.drcnet.com.cn/eDRCnet.common.web/login/login.aspx?gourl=${url}`"
            >
              登录
            </a> -->
            </ul>
          </div>
          <template v-else>
            <span id="more"
              >更多内容，请进入
              <a
                href="https://www.drcnet.com.cn/?g=1"
                target="_blank"
                class="yellow"
                >国研网</a
              >
              |</span
            >
            <span id="login">
              <span id="login-sussess"
                ><span id="login-username" >欢迎，{{ UserMessage.UserName }}</span
                >&nbsp;<a id="login-out" @click="exit()">退出</a></span
              >
            </span>
          </template>
        </template>

        <!-- | <a href="http://www.drcnet.com.cn/DRCNET.Channel.Web/drcnetdrm/drm_setup.asp" target="_blank">插件下载</a>-->
      </div>
    </div>
    <div v-else>
      <div class="page_width">
        <template>
          <div v-if="UserMessage.UserName == undefined && UserMessage.UserName == ''" class="logout">
            <ul class="clearfix">
              <li>
                <span style="cursor: pointer" @click="loginDrc"> 登录 </span>
              </li>
              <li class="register">
                <span id="more"
                  >更多内容，请进入
                  <a
                    href="https://www.drcnet.com.cn/?g=1"
                    target="_blank"
                    style="color: brown"
                    >国研网</a
                  >
                </span>
              </li>
            </ul>
          </div>
          <template v-else>
            <div style="padding: 16px 8px">
              <span id="more"
                >更多内容，请进入
                <a
                  href="https://www.drcnet.com.cn/?g=1"
                  target="_blank"
                  style="color: brown"
                  >国研网</a
                >
              </span>
              <div>
                <span id="login">
                  <span id="login-sussess"
                    ><span id="login-username"
                      >欢迎，{{ UserMessage.UserName }}</span
                    >&nbsp;<a id="login-out" @click="exit()">退出</a></span
                  >
                </span>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import jsonp from "jsonp";
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      url: window.location.href,
      UserName: "",
    };
  },
  computed: {
    ...mapState(["UserMessage"]),
  },
  created() {
    // console.log('this.$route.query.token',this.$route.query.token);
    // window.localStorage.setItem("token", this.$route.query.token)
    // this.login()
    // localStorage.setItem("token", this.$route.query.token);
    // if (this.$route.query.token) {
    // 	window.localStorage.setItem("token", this.$route.query.token)
    // }
    // this.loginDrc();
    this.loginState();
  },
  methods: {
    ...mapMutations(["updateUserMessage"]),
    exit() {
      jsonp(
        "https://user.drcnet.com.cn/userapi/loginController/logOutAllP",
        null,
        (err, data) => {
          if (!data.UserToken) {
            this.$message({
              message: "退出登录成功",
              type: "success",
            });
            this.updateUserMessage("");
            window.location.href =
              window.location.origin + window.localStorage.getItem("userId");
          }
        }
      );
    },
    openVideo() {
      var page = window.open();
      var html =
        '<body style="background:black"><div style="width:85%;margin:auto"><video autoplay controls muted width="100%" src="https://misc.drcnet.com.cn/download/zcfg.mp4"></video></div></body>';
      page.document.write(html);
    },
    async loginDrc(callback, url, callbackPrams) {
      url = url || window.location.href;
      jsonp(
        "https://user.drcnet.com.cn/userapi/loginController/initLoginP",
        {
          flag: "initp",
        },
        (err, data) => {
          if (data) {
            const userMessage = data;
            if (!userMessage.UserToken) {
              window.location.href = `https://user.drcnet.com.cn/#/login?gourl=${url}`;
            } else {
              this.updateUserMessage(data);
              // localStorage.setItem("token", userMessage);
            }
          }
        }
      );
    },
    async loginState(callback, url, callbackPrams) {
      url = url || window.location.href;

      jsonp(
        "https://user.drcnet.com.cn/userapi/loginController/initLoginP",
        {
          flag: "initp",
        },
        (err, data) => {
          if (data) {
            const userMessage = data;
            if (!userMessage.UserToken) {
              
              this.$message("请登录");
            } else {
              this.updateUserMessage(data);
            }
          }
        }
      );
    },
  },
  // watch: {
  //   "$route.query.token"(newToken) {
  //     if (newToken) {
  //       // window.localStorage.setItem("token", newToken);
  //       // this.token = window.localStorage.getItem("token");
  //       jsonp(
  //         "http://user.drcnet.com.cn/userapi/loginController/initLoginP",
  //         null,
  //         (err, data) => {
  //           if (data) {
  //             this.updateUserMessage(data);
  //           }
  //         }
  //       );
  //     }
  //   },
  // },
};
</script>

<style lang="less" scoped>
.top_link {
  background-color: #333;
  color: #fff;
  height: 30px;
  text-align: right;
  font: 12px / 30px "宋体";
}
.page_width {
  width: 1300px;
  margin: 0px auto;
  clear: both;
  .top_link {
    background-color: #333;
    color: #fff;
    height: 30px;
    text-align: right;
    font: 12px / 30px "宋体";
  }
  a {
    color: #fff;
  }
  .login {
    background-color: #f7f7f7;
    border: 1px solid #d1e6f9;
    font-size: 12px;
    padding: 10px;
    width: 200px;
    text-align: left;
    z-index: 500000;
    color: #000;
    line-height: 150%;
  }
  #loginId {
    width: 140px;
    margin-top: 0px;
  }
  #pass {
    width: 140px;
  }
  .keepdiv {
    position: relative;
    left: 39px;
  }
  .loginbtncenter {
    width: 120px;
    margin: auto;
    padding-top: 5px;
    height: 1%;
    overflow: hidden;
    .loginbtn {
      width: 50px;
      height: 24px;
      text-align: center;
      line-height: 200%;
      float: left;
      margin-right: 10px;
      a {
        width: 50px;
        height: 24px;
        display: block;
        text-decoration: none;
        color: #000;
      }
    }
  }
}

.yellow {
  color: #ff0 !important;
  font-weight: bold;
  font-size: 14px;
}
#login-out {
  cursor: pointer;
}
.register {
  list-style: none;
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
  .page_width {
    width: 100%;
    ul {
      padding: 16px 8px;
      li {
        line-height: 24px;
      }
    }
  }
}
</style>